import { render, staticRenderFns } from "./SprintSlider.vue?vue&type=template&id=be52058c&scoped=true"
import script from "./SprintSlider.vue?vue&type=script&lang=js"
export * from "./SprintSlider.vue?vue&type=script&lang=js"
import style0 from "./SprintSlider.vue?vue&type=style&index=0&id=be52058c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be52058c",
  null
  
)

export default component.exports